
<script>
import New from './New2'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
